import React from 'react';
import { useOutletContext } from 'react-router-dom';
import ProjectSessions from '../../../../components/DashboardComponents/ProjectSessions';

/**
 * Sessions tab — table + modals matching Figma 40004184-1498.
 * Shadow / Solo action buttons live in ProjectLayout tabs-actions.
 */
const ProjectSessionsTab = () => {
  const { project } = useOutletContext();
  return <ProjectSessions project={project} />;
};

export default ProjectSessionsTab;
